import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

import info from '../images/infographic.png';

const FAQPage = () => (
  <div>
    <Helmet title="FAQ" />
    <h1>FAQ</h1>

    <h3>Q: What&apos;s the recommended age, player-count, and game time?</h3>
    <p>
      A: You&apos;ll need a minimum of three and a maximum of four players to play.
    </p><p>
      A standard game generally takes about 3 hours to play; the short-game varient takes about 2. 
      Long enough for you to really invest in your empire, but short enough to play on a week-day evening. 
    </p><p>
      Legacy of the Stars is recommended for ages 10 and up. 
    </p>
    <img id="info" src={info} />

    <h3>Q: What is the premise of the game? How do you win?</h3>
    <p>
      A: Legacy of the stars is an epic strategy game where you control one of 8
      unique factions trying to rebuild human civilization after a galactic
      civil war. You want to become the faction whose legacy will shape
      humanity&apos;s future. There are six different kinds of victory point cards
      called &quot;Legacies&quot; for you to earn by doing things like
      establishing outposts on planets, building cities, researching technology,
      and conquering your neighbors.
    </p>
    <p>The first player with 8 Legacy Cards wins.</p>

    <h3>Q: What makes this game special?</h3>
    <p>
      A: The core mechanic, for one, is simple but deep. The glory and vengeance tracks also
      provide a diplomatic catch-up mechanic that diffuses a lot of feel-bad 
      situations. 
    </p>
    <p>
      Like many great games, Legacy of the Stars combines very simple systems in such 
      a way that complexity, depth, and nuance emerge from their interactions. So it’s
      easy to learn, but hard to master. 
    </p>
    <p>
      Another thing you don’t often see in this kind of game is a simple combat
      mechanic that doesn&apos;t hinge on chance or bluffing – so your military
      strategy is more chess-like than Risk-like. Like chess,
      the depth and complexity arise from interactions between simple and
      predictable pieces.
    </p>

    <h3>Q: What was the main inspiration behind the game?</h3>
    <p>
      A: Primarily classic PC space empire building games like Master of Orion
      2. We&apos;d played several other empire-building board games but never found
      one we could play competitively again and again. There were a lot of
      specific design goals we set out to achieve, and the result, after years
      of testing and refining, is something we&apos;re really proud of.
    </p>

    <h3>Q: Is this a finished product or a work in progress?</h3>
    <p>
      It&apos;s a finished product, but that doesn&apos;t mean we&apos;re done with it. 
      As with any game that is balanced for competitive play, there may be errata 
      if we see imbalances in the meta-game. We’re also testing two mini-expansions. 
    </p>

    <h3>
      Q: Tell me more about these &quot;mini-expansions&quot; you&apos;re
      planning…
    </h3>
    <p>
      The Exalted Worlds expansion introduces unique planets whose locations and special 
      properties are only revealed as players defeat the Exalted Guardians protecting them. 
      These planets reveal more of the galaxy&apos;s history and add more flavor
      and variety to the galaxy map itself. 
    </p>
    <p>
      In addition, while the base set includes 8 factions, and a set of 9 technology cards
      which are balanced to work well together, we want to make a mini-expansion
      to introduce 4 more factions and another set of 9 technology cards. The new 
      technologies will be usable in place of the original 9 or can be mixed and matched with them
      to create different technology options and combinations in every game.
    </p>

    <h3>Q: How can I buy Legacy of the Stars?</h3>
    <p>
      A: Legacy of the Stars is currently only available directly from us - email {' '}
      <a href="mailto:contact@legacyofthestars.com">
        contact@legacyofthestars.com
      </a>{' '} to inqure about getting a copy. So far only the only people who have bought one
      are people we know personally or who played the game at a meet-up or game night in Boston and 
      decided it was something they needed to own. (Current copies in existence: 8!) The price is currenlty
      $90 plus shipping (free delivery if you live in the Boston area). 
    </p>

    <h3>Q: Is there going to be a cheaper or better version in the future?</h3>
    <p>
      A: We don&apos;t know for sure. We&apos;re looking into it. The more interest there is 
      the current version, the more likely that becomes.  Having a community of even a dozen 
      or so people who owned their own copies and could report on games played, test print-and-play 
      expansions, and contribute their energy and ideas would be an enormous help. So if 
      you like this game, the best thing you can do for its future is get a copy of the 
      current version and start playing it. 
    </p>


    <h3>Q: $90 is a lot, but I still want to try this game out…</h3>
    <p>
      A: We run games around the Boston area all the time! Send us an email at{' '}
      <a href="mailto:contact@legacyofthestars.com">
        contact@legacyofthestars.com
      </a>  and we&apos;ll let you know when the next opportunity to play is.
    </p>

    <h3>Q: Are you looking for a publisher?</h3>
    <p>
      Yes, we&apos;re open to talking with publishers. If you’re an
      interested publisher feel free to drop us a line. 
    </p>

    <h3>
      Q: I have another question that isn&apos;t listed here, will you answer
      it?
    </h3>
    <p>
      Send us an email at{' '}
      <a href="mailto:contact@legacyofthestars.com">
        contact@legacyofthestars.com
      </a>{' '}
      and we&apos;ll get back to you as soon as we can!
    </p>
  </div>
);

export default FAQPage;



// WEBPACK FOOTER //
// ./src/pages/faq.js